/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_CookingInputs */

const en_homepage_listen_in_cooking = /** @type {(inputs: Homepage_Listen_In_CookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooking`)
};

const es_homepage_listen_in_cooking = /** @type {(inputs: Homepage_Listen_In_CookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cocinando`)
};

/**
* | output |
* | --- |
* | "Cooking" |
*
* @param {Homepage_Listen_In_CookingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_cooking = /** @type {((inputs?: Homepage_Listen_In_CookingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_CookingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_cooking(inputs)
	return en_homepage_listen_in_cooking(inputs)
});